import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLayout, FiBox, FiArrowRight, FiCpu } = FiIcons;

const Paths = () => {
  return (
    <section className="py-24 bg-[#07113a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 text-left">
          {/* Services Path */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="group relative bg-[#2a3658] border border-[#344271] p-10 rounded-[32px] hover:border-[#3b82f6]/50 transition-all duration-300 backdrop-blur-sm shadow-xl"
          >
            <div className="w-14 h-14 bg-[#07113a] rounded-2xl flex items-center justify-center mb-8 group-hover:bg-[#3b82f6] text-[#3b82f6] group-hover:text-white transition-all border border-[#344271]">
              <SafeIcon icon={FiLayout} className="text-2xl" />
            </div>
            <h3 className="text-2xl font-black text-white mb-4 uppercase tracking-tight">I need something built</h3>
            <p className="text-[#e2e8f0] text-lg mb-8 leading-relaxed font-medium">
              Websites, customer apps, and custom software—built for your business, not pitched to you.
            </p>
            <Link to="/contact" className="inline-flex items-center text-[#3b82f6] font-black uppercase tracking-widest text-sm group-hover:gap-2 transition-all">
              Local services <SafeIcon icon={FiArrowRight} className="ml-2" />
            </Link>
          </motion.div>

          {/* AI Consulting Path */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="group relative bg-[#2a3658] border border-[#344271] p-10 rounded-[32px] hover:border-[#3b82f6]/50 transition-all duration-300 backdrop-blur-sm shadow-xl"
          >
            <div className="w-14 h-14 bg-[#07113a] rounded-2xl flex items-center justify-center mb-8 group-hover:bg-[#3b82f6] text-[#3b82f6] group-hover:text-white transition-all border border-[#344271]">
              <SafeIcon icon={FiCpu} className="text-2xl" />
            </div>
            <h3 className="text-2xl font-black text-white mb-4 uppercase tracking-tight">AI Consulting</h3>
            <p className="text-[#e2e8f0] text-lg mb-8 leading-relaxed font-medium">
              Practical AI strategies to automate workflows, enhance customer comms, and integrate intelligence into your business.
            </p>
            <Link to="/contact" className="inline-flex items-center text-[#3b82f6] font-black uppercase tracking-widest text-sm group-hover:gap-2 transition-all">
              Explore AI <SafeIcon icon={FiArrowRight} className="ml-2" />
            </Link>
          </motion.div>

          {/* Product Path */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="group relative bg-[#2a3658] border border-[#344271] p-10 rounded-[32px] hover:border-[#3b82f6]/50 transition-all duration-300 backdrop-blur-sm shadow-xl"
          >
            <div className="w-14 h-14 bg-[#07113a] rounded-2xl flex items-center justify-center mb-8 group-hover:bg-[#3b82f6] text-[#3b82f6] group-hover:text-white transition-all border border-[#344271]">
              <SafeIcon icon={FiBox} className="text-2xl" />
            </div>
            <h3 className="text-2xl font-black text-white mb-4 uppercase tracking-tight">Product Studio</h3>
            <p className="text-[#e2e8f0] text-lg mb-8 leading-relaxed font-medium">
              Explore our suite of consumer products—from family safety tools to advanced route planning and productivity apps.
            </p>
            <Link to="/portfolio" className="inline-flex items-center text-[#3b82f6] font-black uppercase tracking-widest text-sm group-hover:gap-2 transition-all">
              View products <SafeIcon icon={FiArrowRight} className="ml-2" />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Paths;